import GrupoPermissaoService from "@/services/GrupoPermissaoService"

export const actions = {
    cadastrarGrupoPermissao: ({commit, dispatch}) => {
        commit('setGrupoPermissao', {}),
        dispatch('setModalCadastroGrupoPermissao', true)
    },
    listarGrupoPermissao: ({commit}, data) => {
        commit('setOverlay', true)
        GrupoPermissaoService.listar(data)
        .then(res => {
            commit('setOverlay', false)
            commit('setGruposPermissoes', res.data)
            
        })
        .catch(e => {
            commit('setOverlay', false)
            console.log(e)
        })
    },
    visualizarGrupoPermissao: ({commit, dispatch}, data) => {
        commit('setGrupoPermissao', data)
        dispatch('setModalCadastroGrupoPermissao', true)
    },
    
    salvarGrupoPermissao: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        GrupoPermissaoService.salvar(data)
        .then(res => {
            commit('setGrupoPermissao', res.data)
            commit('addGrupoPermissao', res.data)
            commit('setOverlay', false)
            commit('snackbarSuccess', 'Grupo cadastrado.')
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao cadastrar.')
        })
    },
    atualizarGrupoPermissao: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        GrupoPermissaoService.atualizar(data)
        .then(res => {
            commit('setOverlay', false)
            commit('snackbarInfo', 'Grupo atualizado.')
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao atualizar.')
        })
    },
    excluirGrupoPermissao: ({commit, dispatch}, data) => {
        dispatch('setModalExcluirGrupoPermissao', false)
        dispatch('setModalCadastroGrupoPermissao', false)
        commit('setOverlay', true)
        GrupoPermissaoService.excluir(data.id)
        .then(res => {
            commit('setOverlay', false)
            commit('removeGrupoPermissao', res.data)
            commit('snackbarError', 'Grupo excluído.')
        })
        .catch(e => {
            commit('snackbarError', 'Erro ao excluir grupo.')
        })
    },
    setModalCadastroGrupoPermissao: ({commit}, status) => {
        commit('setModalCadastrarGrupoPermissao', false)
        setTimeout(() => {
            commit('setModalCadastrarGrupoPermissao', status)
        }, 100);
    },
    setModalExcluirGrupoPermissao: ({commit}, status) => {
        commit('setModalExcluirGrupoPermissao', false)
        setTimeout(() => {
            commit('setModalExcluirGrupoPermissao', status)
        }, 100);
    },
}

export default {}